/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { ClientId } from '../../models/client-id';
import { FinnairServiceCatalogV3 } from '../../models/finnair-service-catalog-v-3';

export interface GetServiceCatalogByOrderV3$Params {
  orderId: string;
  hash?: string;
  frontEndQuota?: boolean;

/**
 * Session ID in UUID format used to aggregate all the calls for a single customer
 */
  'X-Session-Id'?: string;

/**
 * Client ID representing the caller system
 */
  'X-Client-Id'?: ClientId;

/**
 * W3C Trace Context traceparent header used for distributed tracing
 */
  traceparent?: string;

/**
 * W3C Trace Context tracestate header used for distributed tracing
 */
  tracestate?: string;

/**
 * W3C Baggage header used to propagate contextual key-value pairs
 */
  baggage?: string;
}

export function getServiceCatalogByOrderV3(http: HttpClient, rootUrl: string, params: GetServiceCatalogByOrderV3$Params, context?: HttpContext): Observable<DapiHttpResponse<FinnairServiceCatalogV3>> {
  const rb = new DapiRequestBuilder(rootUrl, getServiceCatalogByOrderV3.PATH, 'get');

  if (params) {
    rb.query('orderId', params.orderId, {});
    rb.query('hash', params.hash, {});
    rb.query('frontEndQuota', params.frontEndQuota, {});
    rb.header('X-Session-Id', params['X-Session-Id'], {});
    rb.header('X-Client-Id', params['X-Client-Id'], {});
    rb.header('traceparent', params.traceparent, {});
    rb.header('tracestate', params.tracestate, {});
    rb.header('baggage', params.baggage, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<FinnairServiceCatalogV3>;
    }),
    catchErrorAsJson()
  );
}

getServiceCatalogByOrderV3.PATH = '/api/v3/services/order';
